import React, { Component } from 'react';
import Modal from "./Modal.js";
import ModalVentas from '../Ventas/Modal';
import ParadigmaTable from "../../components/ParadigmaTable/ParadigmaTable.js";
import DateFilter from "../../components/ParadigmaTable/DateFilter";
import api from "../../api/api.js";
import moment from 'moment';

class Consultas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Fecha",
                    id: "fecha",
                    accessor: d => moment(d.fecha).format('DD/MM/YYYY'),
                    className: "text-center",
                    show: true,
                    width: 100,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
                },
                {
                    Header: "Cliente",
                    id: "cliente_nombre",
                    accessor: "cliente_nombre",
                    show: true,
                },
                {
                    Header: "Vendedor",
                    id: "vendedor_nombre",
                    accessor: "vendedor_nombre",
                    show: true,
                },
                {
                    Header: "Loteo",
                    id: "loteo_nombre",
                    //accessor: d => d.loteo.nombre,
                    accessor: "loteo_nombre",
                    show: true,
                },
                {
                    Header: "Lote",
                    id: "lote_nombre",
                    accessor: "lote_nombre",
                    show: true,
                },
            ]
        };
    }

    render() {
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        component: props => <Modal {...props} action="CREATE"/>,
                        permission: 'ventas_consultas_new',
                    },
                    {
                        edit: true,
                        component: props => <Modal {...props} action="EDIT" />,
                        permission: 'ventas_consultas_edit',
                    },
                    {
                        detail: true,
                        component: props => <Modal {...props} action="DETAIL" />,
                        permission: 'ventas_consultas_detail',
                    },
                    {
                        edit: true,
                        component: props => <Modal {...props} action="DELETE" />,
                        permission: 'ventas_consultas_delete',
                    },
                    {
                        create: true,
                        component: props => <ModalVentas {...props} action="CONSULTA" />,
                        permission: 'ventas_ventas_new',
                    }

                ]}
                depth={2}
                apiUrl={api.ventas.consultas}
                columns={this.state.columns}
                exportUrl={api.ventas.consultas}
                title={"Consultas"}
            />
        );
    }
}

export default Consultas;


// WEBPACK FOOTER //
// ./src/views/Consultas/Consultas.js